module.exports = __webpack_public_path__ + "static/media/homeStoreWeb.2cb77b9a.png";